
<template>
  <div>
    <a-steps :current="current">
      <a-step title="获取验证码"/>
      <a-step title="重置密码"/>
    </a-steps>
    <a-form :form="form">
      <div class="steps-content" v-if="current == 0">
        <a-form-item>
          <a-input
            v-decorator="['phone',
                          {rules: [{ required: true, message: '请输入正确的手机号'},
                                   { validator: this.handlePhoneCheck }],
                           validateTrigger: ['change', 'blur']}]"
            size="large"
            placeholder="11 位手机号">
            <a-select slot="addonBefore" size="large" defaultValue="+86">
              <a-select-option value="+86">+86</a-select-option>
              <a-select-option value="+87">+87</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-row :gutter="12">
          <a-col class="gutter-row" :span="16">
            <a-form-item>
              <a-input
                v-decorator="['smsCode', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]"
                size="large"
                type="text"
                placeholder="验证码">
                <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <a-button
              class="getCaptcha"
              size="large"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getCaptcha"
              v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"></a-button>
          </a-col>
        </a-row>
      </div>
      <div class="steps-content" v-if="current == 1">
        <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
          <template slot="content">
            <div :style="{ width: '240px' }" >
              <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
              <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor " />
              <div style="margin-top: 10px;">
                <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
              </div>
            </div>
          </template>
          <a-form-item>
            <a-input
              v-decorator="['password', {rules: [{ required: true, message: '请输入密码' },{min:6,message:'至少输入6位密码'},{max:18,message:'最多输入18位密码'}],
                                         validateTrigger: ['change', 'blur']}]"
              size="large"
              type="password"
              autocomplete="false"
              placeholder="请输入密码"></a-input>
          </a-form-item>
        </a-popover>

        <a-form-item>
          <a-input
            v-decorator="['password2', {rules: [{ required: true, message: '请再次输入密码' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"
            size="large"
            type="password"
            autocomplete="false"
            placeholder="确认密码"></a-input>
        </a-form-item>
      </div>
      <div align="right" class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next(schoolObj)" > 下一步 </a-button>
        <a-button v-if="current == steps.length - 1" type="primary" @click="resetPassword(schoolObj)">重置密码 </a-button>
      </div>
    </a-form>
  </div>
</template>
<script>
import { getSmsCaptcha, queryByPhone, checkCode, resetPwd } from '@/api/resetPwd'
export default {
  name: 'ResetPwd',
  data () {
    return {
      current: 0,
      steps: [{
        title: '获取验证码',
        content: 'First-content'
      }, {
        title: 'Second',
        content: 'Second-content'
      }],
      form: this.$form.createForm(this),
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      schoolObj: {}
    }
  },
  methods: {
    next (schoolObj) {
      this.form.validateFields((err, values) => {
        if (!err) {
          schoolObj.phone = values.phone
          schoolObj.smsCode = values.smsCode
          checkCode(schoolObj).then((res) => {
            if (res.result === 1) {
              this.$message.error('验证码已失效')
            } else if (res.result === 2) {
              this.$message.error('验证码不正确')
            } else {
              this.current++
            }
          }).catch(() => {
            this.$message.error('系统异常')
          })
        }
      })
    },
    handlePhoneCheck (rule, value, callback) {
      if (value !== '' && typeof (value) !== 'undefined') {
        if (!/^1[0-9]{10}$/.test(value)) {
          callback(new Error('格式不正确，请输入正确的手机号码'))
          return false
        }
        queryByPhone(value).then(res => {
          if (res.result === 0) {
            callback(new Error('系统不存在此手机号码，请重新输入'))
            return false
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    },
    getCaptcha (e) {
      e.preventDefault()
      const that = this
      this.form.validateFields(['phone'], { force: true },
        (err, values) => {
          if (!err) {
            this.state.smsSendBtn = true
            const interval = window.setInterval(() => {
              if (that.state.time-- <= 0) {
                that.state.time = 60
                that.state.smsSendBtn = false
                window.clearInterval(interval)
              }
            }, 1000)
            const hide = this.$message.loading('验证码发送中..', 0)
            getSmsCaptcha(values.phone).then(res => {
              setTimeout(hide, 3000)
            }).catch(err => {
              setTimeout(hide, 1)
              clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
              this.requestFailed(err)
            })
          }
        }
      )
    },
    handlePasswordCheck (rule, value, callback) {
      const password = this.form.getFieldValue('password')
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    resetPassword (schoolObj) {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.password !== values.password2) {
            this.$message.error('两次密码不一致')
            return false
          } else {
            values.phone = schoolObj.phone
            resetPwd(values).then((res) => {
              this.$message.success('重置密码成功')
              this.$parent.showLogin()
            }).catch(() => {
              this.$message.error('重置密码失败')
            })
          }
        }
      })
    }

  }
}
</script>
<style scoped>
  .steps-content {
    margin-top: 16px;
    padding-top: 20px;
  }
  .steps-action {
    margin-top: 24px;
  }
</style>
